// Utilities
import { lazy } from "react";
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
export const MyPortfoliosPageLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "planner-myportfoliospage" */ "./MyPortfoliosPage")).then((bundle)=>{
        return {
            default: bundle.MyPortfoliosPage
        };
    });
export const LazyMyPortfoliosPage = /*#__PURE__*/ lazy(MyPortfoliosPageLazyLoader);
